import React from 'react'
import PropTypes from 'prop-types'
import { sizes, useTheme } from '@qflow/theme'

export function TrashCan({
  size = sizes.X_SMALL,
  colour = 'currentColor',
  ...props
}) {
  const theme = useTheme()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      style={{ width: size, height: `calc(${size} * 13/12)` }}
      {...props}
    >
      <g fill={colour || theme.secondary.fg} fillRule="nonzero">
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M11.5 2.5H9.5V1.25C9.5 0.698438 9.05156 0.25 8.5 0.25H3.5C2.94844 0.25 2.5 0.698438 2.5 1.25V2.5H0.5C0.223437 2.5 0 2.72344 0 3V3.5C0 3.56875 0.05625 3.625 0.125 3.625H1.06875L1.45469 11.7969C1.47969 12.3297 1.92031 12.75 2.45312 12.75H9.54688C10.0813 12.75 10.5203 12.3313 10.5453 11.7969L10.9312 3.625H11.875C11.9438 3.625 12 3.56875 12 3.5V3C12 2.72344 11.7766 2.5 11.5 2.5ZM8.375 2.5H3.625V1.375H8.375V2.5Z"
          fill={colour}
        />
      </g>
    </svg>
  )
}

TrashCan.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
